import _toConsumableArray from "/root/workspace/sportal365-cms_release-3.242.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import * as symbol from './symbol.js';
import * as time from './time.js';
import * as env from './environment.js';
import * as func from './function.js';
export var BOLD = symbol.create();
export var UNBOLD = symbol.create();
export var BLUE = symbol.create();
export var GREY = symbol.create();
export var GREEN = symbol.create();
export var RED = symbol.create();
export var PURPLE = symbol.create();
export var ORANGE = symbol.create();
export var UNCOLOR = symbol.create();
/* c8 ignore start */

/**
 * @param {Array<string|Symbol|Object|number>} args
 * @return {Array<string|object|number>}
 */

export var computeNoColorLoggingArgs = function computeNoColorLoggingArgs(args) {
  var strBuilder = [];
  var logArgs = []; // try with formatting until we find something unsupported

  var i = 0;

  for (; i < args.length; i++) {
    var arg = args[i];

    if (arg.constructor === String || arg.constructor === Number) {
      strBuilder.push(arg);
    } else if (arg.constructor === Object) {
      logArgs.push(JSON.stringify(arg));
    }
  }

  return logArgs;
};
/* c8 ignore stop */

var loggingColors = [GREEN, PURPLE, ORANGE, BLUE];
var nextColor = 0;
var lastLoggingTime = time.getUnixTime();
/* c8 ignore start */

/**
 * @param {function(...any):void} _print
 * @param {string} moduleName
 * @return {function(...any):void}
 */

export var createModuleLogger = function createModuleLogger(_print, moduleName) {
  var color = loggingColors[nextColor];
  var debugRegexVar = env.getVariable('log');
  var doLogging = debugRegexVar !== null && (debugRegexVar === '*' || debugRegexVar === 'true' || new RegExp(debugRegexVar, 'gi').test(moduleName));
  nextColor = (nextColor + 1) % loggingColors.length;
  moduleName += ': ';
  return !doLogging ? func.nop : function () {
    var timeNow = time.getUnixTime();
    var timeDiff = timeNow - lastLoggingTime;
    lastLoggingTime = timeNow;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _print.apply(void 0, [color, moduleName, UNCOLOR].concat(_toConsumableArray(args.map(function (arg) {
      return typeof arg === 'string' || typeof arg === 'symbol' ? arg : JSON.stringify(arg);
    })), [color, ' +' + timeDiff + 'ms']));
  };
};
/* c8 ignore stop */